import { useEffect } from 'react';
import { LatestRef } from './types';
import { ALERT_MESSAGE } from 'config/constants';
import { setTimeout } from 'lib/window';
import useAlert from 'hooks/useAlert';

export function useAmendmentConfirmedFlow(ref: LatestRef) {
  const { displayAlert } = useAlert();

  const { amendment } = ref.current;

  useEffect(() => {
    if (amendment?.state !== 'ACCEPTED') return;

    const { booking, navigateTo } = ref.current;

    // Navigate in the next tick to allow a page view to be recorded with /confirmed suffix
    // see: ./useSyncUrlWithState.ts
    // This hack can be removed when a real confirmation page is built
    setTimeout(() => {
      navigateTo.booking('replace', booking.id);
      displayAlert({ type: 'success', message: ALERT_MESSAGE.CHANGE_DATE_SUCCESS });
    }, 1);
  }, [ref, amendment?.state, displayAlert]);
}
